import {DocumentFrom} from "../../helper/enums";

export function modifyInvoiceOFGetServiceInvoicesByDates(srvInvoice,type) {
    let tmpDocInv= {};
    if(srvInvoice['customer']['tcIdNumber']) {
        tmpDocInv.givenName = srvInvoice['customer']['firstName'];
        tmpDocInv.familyName = srvInvoice['customer']['lastName'];
        tmpDocInv.title = tmpDocInv.givenName + " " +tmpDocInv.familyName;
    }else {
        tmpDocInv.formattedName = srvInvoice['customer']['customerName'];
        tmpDocInv.title = tmpDocInv.formattedName;
    }

    tmpDocInv.city = srvInvoice['customer']['cityName'] ;
    tmpDocInv.documentNumber = srvInvoice.formalInvoiceNumber+ "";
    tmpDocInv.profileId = (type === "WARRANTY_INVOICE" ? "TICARIFATURA": "TEMELFATURA");
    tmpDocInv.invoiceTypeCode = srvInvoice.useTevkifat ? "TEVKIFAT" : "SATIS";
    tmpDocInv.documentUuid = srvInvoice.documentUuid;
    tmpDocInv.issueDate = srvInvoice['invoiceDate'].replace(" ", "T");
    tmpDocInv.vknTckn = srvInvoice['customer']['tcIdNumber'] ? srvInvoice['customer']['tcIdNumber'] : srvInvoice['customer']['taxNumber'];
    tmpDocInv.tmpDocConnectorExCustomer = {
        vknTckn: srvInvoice['customer']['tcIdNumber'] ? srvInvoice['customer']['tcIdNumber'] : srvInvoice['customer']['taxNumber'],
        formattedName:  srvInvoice['customer']['taxNumber'] ? srvInvoice['customer']['customerName'] : null,
        givenName: srvInvoice['customer']['tcIdNumber'] ? srvInvoice['customer']['firstName'] : null,
        familyName: srvInvoice['customer']['tcIdNumber'] ? srvInvoice['customer']['lastName'] : null,
        cityName: srvInvoice['customer']['cityName'],
        citySubdivisionName: srvInvoice['customer']['townName'],
        countryName: srvInvoice['customer']['countryName'],
        streetName:srvInvoice['customer']['addressLine1'],
        postalZone: srvInvoice['customer']['postCode'],
        telephone: srvInvoice['customer']['gsmNumber'],
        email:srvInvoice['customer']['email'],
        fax: srvInvoice['customer']['faxNumber'],
        taxOffice:srvInvoice['customer']['taxOffice'],
        postboxAlias: null,
    };

    tmpDocInv.retailCustomer= false;
    tmpDocInv.trdDocExternalCustomer=null;
    tmpDocInv.lineExtensionAmount =  srvInvoice.totalBaseAmount;
    tmpDocInv.taxExclusiveAmount =  srvInvoice.totalBaseAmount - srvInvoice.totalTaxAmount;
    tmpDocInv.taxInclusiveAmount = srvInvoice.totalInvoiceAmount + (srvInvoice.useTevkifat ? srvInvoice.totalTevkifatAmount : 0);
    tmpDocInv.payableAmount = srvInvoice.totalInvoiceAmount;
   tmpDocInv.allowanceTotalAmount = srvInvoice.totalDiscountAmount ? srvInvoice.totalDiscountAmount : 0;
    tmpDocInv.trdDocInvoiceNotes= [
        {note:srvInvoice.note!= null ?srvInvoice.note:'',recordId: null},
        {note:srvInvoice.plateNumber != null ? ("PLAKA: ,"+srvInvoice.plateNumber) : '',recordId: null},
        {note:srvInvoice.workOrderNumber != null ? ("İŞ EMRİ NUMARASI: ,"+srvInvoice.workOrderNumber) : '',recordId: null},
        {note:srvInvoice.lastKM != null ? ("KM: ,"+srvInvoice.lastKM) : '',recordId: null},
    ];

    if(srvInvoice.isExWashing){
        tmpDocInv.trdDocInvoiceNotes.push({note:'Araç yıkaması ücretsiz olarak yapılmıştır.',recordId: null});
    }

    let invoiceLines = [];
    let eInvoiceTypeID = null;
    if(type === "SERVICE_INVOICE") {
        eInvoiceTypeID=3;
        srvInvoice.invoiceDetailResponseModels.map(line => {

            if(line.dealerDiscountAmount == 0) line.dealerDiscountPercent = 0;
            if(line.campaignDiscountAmount == 0) line.campaignDiscountPercent = 0;
            if(line.blueCardDiscountAmount == 0) line.blueCardDiscountPct = 0;
                let invoiceLine = {
                    "recordId": null,
                    "itemCode": null,
                    "itemName": line.code + " " + line.name,
                    "quantity": line.quantity,
                    "unit": "C62",
                    "unitPrice": line.price,
                    "lineExtensionAmount": line.discountedAmount,
                    "trdDocInvoiceLineCharges": [
                        {
                            "recordId": null,
                            "taxCode": {
                                "recordId": 5,
                                "code": "0000",
                                "shortName": "İSKONTO",
                                "longName": "İSKONTO",
                                "direction": -1,
                                "calculatedBy": "AMOUNT",
                                "priority": -2,
                                "affectTaxableAmount": 1,
                                "mm": 0,
                                "smm": 0,
                                "inv": 1,
                                "isAffectKdv": 1
                            },
                            "direction": -1,
                            "percentage": (line.blueCardDiscountPct +
                                line.dealerDiscountPercent +
                                line.campaignDiscountPercent +
                                line.scrapLaborDiscountPercentage +
                                line.scrapSparePartDiscountPercentage
                            ),
                            "taxableAmount": line.quantitiedPrice,
                            "perUnitAmount": 0,
                            "amount": line.discountAmount,
                            "calculatedBy": "AMOUNT",
                        },
                        {
                            "recordId": null,
                            "taxCode": {
                                "recordId": 1,
                                "code": "0015",
                                "shortName": "KDV GERCEK",
                                "longName": "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                "direction": 1,
                                "calculatedBy": "AMOUNT",
                                "priority": 4,
                                "affectTaxableAmount": 0,
                                "mm": 0,
                                "smm": 1,
                                "inv": 1,
                                "isAffectKdv": 0
                            },
                            "direction": 1,
                            "percentage": line.taxPercent,
                            "taxableAmount": line.discountedAmount,
                            "perUnitAmount": 0,
                            "amount": line.taxAmount,
                            "calculatedBy": "AMOUNT",
                        },
                    ],
                };

            if(srvInvoice.useTevkifat && line.tevkifatPercent>0) {
                let tempTevkifatCharge =     {
                    "recordId": null,
                    "taxCode": {
                        "recordId": null,
                        "code": "9015",
                        "shortName": "KDV TEVKİFATI",
                        "longName": "KDV TEVKİFATI",
                        "direction": 1,
                        "calculatedBy": "AMOUNT",
                        "priority": 4,
                        "affectTaxableAmount": 0,
                        "mm": 0,
                        "smm": 1,
                        "inv": 1,
                        "isAffectKdv": 0
                    },
                    "direction": -1,
                   "percentage": 70,
                    "taxableAmount": line.taxAmount,
                    "perUnitAmount": 0,
                    "amount": line.taxAmount * 0.7,
                    "calculatedBy": "AMOUNT",
                    "withholdingCode": "603",

                };
                invoiceLine.trdDocInvoiceLineCharges.push(tempTevkifatCharge);
            }
            invoiceLines.push(invoiceLine);
            }
        )
    }


    if(type === "SPAREPART_INVOICE") {
        eInvoiceTypeID=4;
        srvInvoice.retailSalesInvoiceDetails.map(line => {
                let invoiceLine = {
                    "recordId": null,
                    "itemCode": null,
                    "itemName": line.sparePart.code + " " + line.sparePart.name,
                    "quantity": line.quantity,
                    "unit": "C62",
                    "unitPrice": line.price,
                    "lineExtensionAmount": line.discountedAmount,
                    "trdDocInvoiceLineCharges": [
                        {
                            "recordId": null,
                            "taxCode": {
                                "recordId": 5,
                                "code": "0000",
                                "shortName": "İSKONTO",
                                "longName": "İSKONTO",
                                "direction": -1,
                                "calculatedBy": "AMOUNT",
                                "priority": -2,
                                "affectTaxableAmount": 1,
                                "mm": 0,
                                "smm": 0,
                                "inv": 1,
                                "isAffectKdv": 1
                            },
                            "direction": -1,
                            "percentage": line.discountPercent,
                            "taxableAmount": line.quantitiedPrice,
                            "perUnitAmount": 0,
                            "amount": line.discountAmount,
                            "calculatedBy": "AMOUNT",
                        },
                        {
                            "recordId": null,
                            "taxCode": {
                                "recordId": 1,
                                "code": "0015",
                                "shortName": "KDV GERCEK",
                                "longName": "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                "direction": 1,
                                "calculatedBy": "AMOUNT",
                                "priority": 4,
                                "affectTaxableAmount": 0,
                                "mm": 0,
                                "smm": 1,
                                "inv": 1,
                                "isAffectKdv": 0
                            },
                            "direction": 1,
                            "percentage": line.taxPercent,
                            "taxableAmount": line.discountedAmount,
                            "perUnitAmount": 0,
                            "amount": line.taxAmount,
                            "calculatedBy": "AMOUNT",
                        }
                    ],
                };
                invoiceLines.push(invoiceLine);
            }
        )
    }

    if(type === "SALES_INVOICE"){
        eInvoiceTypeID=1;
    }

    if(type === "WARRANTY_INVOICE"){
        eInvoiceTypeID=5;
        srvInvoice.invoiceDetail.sparePartDetails.map(line =>{
            let invoiceLine = {
                "recordId": null,
                "itemCode": null,
                "itemName": line.code + " " + line.name,
                "quantity": line.quantity,
                "unit": "C62",
                "unitPrice": line.price,
                "lineExtensionAmount": line.quantitedPrice,
                "trdDocInvoiceLineCharges": [
                    {
                        "recordId": null,
                        "taxCode": {
                            "recordId": 5,
                            "code": "0000",
                            "shortName": "İSKONTO",
                            "longName": "İSKONTO",
                            "direction": -1,
                            "calculatedBy": "AMOUNT",
                            "priority": -2,
                            "affectTaxableAmount": 1,
                            "mm": 0,
                            "smm": 0,
                            "inv": 1,
                            "isAffectKdv": 1
                        },
                        "direction": -1,
                        "percentage": 0,
                        "taxableAmount": line.quantitedPrice,
                        "perUnitAmount": 0,
                        "amount": 0,
                        "calculatedBy": "AMOUNT",
                    },
                    {
                        "recordId": null,
                        "taxCode": {
                            "recordId": 1,
                            "code": "0015",
                            "shortName": "KDV GERCEK",
                            "longName": "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            "direction": 1,
                            "calculatedBy": "AMOUNT",
                            "priority": 4,
                            "affectTaxableAmount": 0,
                            "mm": 0,
                            "smm": 1,
                            "inv": 1,
                            "isAffectKdv": 0
                        },
                        "direction": 1,
                        "percentage": line.taxPercent,
                        "taxableAmount": line.quantitedPrice,
                        "perUnitAmount": 0,
                        "amount": line.taxAmount,
                        "calculatedBy": "AMOUNT",
                    }
                ],
            };
            invoiceLines.push(invoiceLine);
        });


        srvInvoice.invoiceDetail.laborDetails.map(line =>{
            let invoiceLine = {
                "recordId": null,
                "itemCode": null,
                "itemName": line.code + " " + line.name,
                "quantity": line.workTime,
                "unit": "C62",
                "unitPrice": line.price,
                "lineExtensionAmount": line.quantitedPrice,
                "trdDocInvoiceLineCharges": [
                    {
                        "recordId": null,
                        "taxCode": {
                            "recordId": 5,
                            "code": "0000",
                            "shortName": "İSKONTO",
                            "longName": "İSKONTO",
                            "direction": -1,
                            "calculatedBy": "AMOUNT",
                            "priority": -2,
                            "affectTaxableAmount": 1,
                            "mm": 0,
                            "smm": 0,
                            "inv": 1,
                            "isAffectKdv": 1
                        },
                        "direction": -1,
                        "percentage": 0,
                        "taxableAmount": line.quantitedPrice,
                        "perUnitAmount": 0,
                        "amount": 0,
                        "calculatedBy": "AMOUNT",
                    },
                    {
                        "recordId": null,
                        "taxCode": {
                            "recordId": 1,
                            "code": "0015",
                            "shortName": "KDV GERCEK",
                            "longName": "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            "direction": 1,
                            "calculatedBy": "AMOUNT",
                            "priority": 4,
                            "affectTaxableAmount": 0,
                            "mm": 0,
                            "smm": 1,
                            "inv": 1,
                            "isAffectKdv": 0
                        },
                        "direction": 1,
                        "percentage": line.taxPercent,
                        "taxableAmount": line.quantitedPrice, //line.quantified de olabilir mi?
                        "perUnitAmount": 0,
                        "amount": line.taxAmount,
                        "calculatedBy": "AMOUNT",
                    }
                ],
            };
            invoiceLines.push(invoiceLine);
        })
    }
   console.log("srvInvoice",srvInvoice);
    console.log("tmpDocInv",tmpDocInv);
    tmpDocInv.referenceId = srvInvoice.invoiceNumber+"&"+eInvoiceTypeID;
    tmpDocInv.trdDocInvoiceLines= invoiceLines;
    tmpDocInv.documentCurrencyCode= "TRY";
    tmpDocInv.from = DocumentFrom.CONNECTOR;
    return tmpDocInv;
}